import * as React from 'react';
import loadable from '@loadable/component';

// Import components
import { Loader } from 'components/elements';

const LoadableMng = ({ func }: { func: any }) =>
	loadable(func, {
		fallback: <Loader />
	});

export default LoadableMng;
